import { KeyValueObject, SystemEntity } from '../../models';
import {
    ADVISER_FORM_ID,
    CAMPAIGN_FORM_ID,
    DOCUMENT_FORM_ID,
    EVENT_FORM_ID,
    EVENT_PARTICIPATION_FORM_ID,
    INTERMEDIARY_FORM_ID,
    LETTER_FORM_ID,
    LIST_FORM_ID,
    MEETING_FORM_ID,
    OPPORTUNITY_FORM_ID,
    ORGANISATION_FORM_ID,
    PERSON_FORM_ID,
    PHONECALL_FORM_ID,
    TASK_FORM_ID,
    USER_FORM_ID,
} from './form-ids.static';

export const FORM_ID_ENTITY_MAP: KeyValueObject<SystemEntity> = {
    [ADVISER_FORM_ID]: SystemEntity.Adviser,
    [CAMPAIGN_FORM_ID]: SystemEntity.Campaign,
    [DOCUMENT_FORM_ID]: SystemEntity.Document,
    [EVENT_FORM_ID]: SystemEntity.Event,
    [EVENT_PARTICIPATION_FORM_ID]: SystemEntity.EventParticipation,
    [INTERMEDIARY_FORM_ID]: SystemEntity.Intermediary,
    [LETTER_FORM_ID]: SystemEntity.Letter,
    [LIST_FORM_ID]: SystemEntity.List,
    [MEETING_FORM_ID]: SystemEntity.Activity,
    [OPPORTUNITY_FORM_ID]: SystemEntity.OpportunityTeamMember,
    [ORGANISATION_FORM_ID]: SystemEntity.Party,
    [PERSON_FORM_ID]: SystemEntity.Party,
    [PHONECALL_FORM_ID]: SystemEntity.Activity,
    [TASK_FORM_ID]: SystemEntity.Task,
    [USER_FORM_ID]: SystemEntity.User,
};
